import React from 'react';
import Terms from '@/components/contents/user/Terms/Terms';
export default function TermPage() {
    return (
        <div className="terms">
            <div className="login_logo">
                <img src={require('@/resources/assets/images/logo.png')} alt="logo" />
            </div>
            <div className="bg_left">
                <div className="log_box">
                    <div className="login_inner">
                        <Terms />
                    </div>
                </div>
            </div>
        </div>
    );
}
